/**
 * Retrieves the file extension from a given filename.
 *
 * @src https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
 * @param filename - The name of the file.
 * @param lowercase - Whether to return the extension in lowercase. Default is true.
 * @returns The file extension.
 */

export const getFileExtension = (filename: string, lowercase = true): string => {
  const extension = filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);

  return lowercase ? extension.toLocaleLowerCase() : extension;
};
